<div class="dialog-default">
  <h1 mat-dialog-title>Mise à jour</h1>
  <p class="px-4">Une nouvelle version du site est disponible !</p>
  <div class="d-flex flex-row justify-content-evenly">
    <button (click)="dismiss()" class="btn btn-primary my-2 mx-4" type="button">Recharger la page</button>
  </div>
</div>
